<template>
    <div>

        <div class="vat-toggle">
            <span>Exc. <span class="vat">VAT</span></span>
            <label class="switch">
                <input type="checkbox" v-model="show">
                <span class="slider round"></span>
            </label>
            <span>Inc. <span class="vat">VAT</span></span>
        </div>
    </div>
</template>

<script>
    import Tax from '../../Services/Tax.js';

    export default {
        data() {
            return {
                tax: Tax
            }
        },
        computed: {
            show: {
                get: function() {
                    return this.tax.show;
                },
                set: function(val) {
                    this.tax.shouldShow(val);
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/TaxToggle.vue